import { css } from 'styled-components';

import { slideUpKeyframe, spinKeyframe } from './keyframes';

export const slideUp = css`
	opacity: 0;
	display: block;
	animation: ${slideUpKeyframe} 1s ease forwards;
`;

export const spin = css`
	animation: ${spinKeyframe} 1s linear infinite;
`;

export default {
	slideUp,
	spin
};
